import firebase from 'firebase';

var firebaseConfig = {
  apiKey: 'AIzaSyAKEXQWnI6KnrPljEpKtTQ6VwO3cbIRdUY',
  authDomain: 'calendar-appointments-eddd5.firebaseapp.com',
  databaseURL: 'https://calendar-appointments-eddd5.firebaseio.com',
  projectId: 'calendar-appointments-eddd5',
  storageBucket: 'calendar-appointments-eddd5.appspot.com',
  messagingSenderId: '267742786820',
  appId: '1:267742786820:web:c752d1765920c799ee0c51',
  measurementId: 'G-T234KKV5RH',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.analytics();
